/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
// Material Dashboard 2 React components
import {
  IconButton,
  TextField,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
  Snackbar,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  PaperComponent,
  convertNumbersToStrings,
} from "../../../utils/constants";
import { useTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import colors from "assets/theme/base/colors";
import { useMaterialUIController } from "context";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
const defaultValue = {
  name: "",
  note: "",
};
const CRUDGroupMenu = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
}) => {
  // state lỗi giá trị từ form
  const [errors, setErrors] = useState({
    name: "",
    error: "",
  });
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const themeLight = createTheme({
    palette: {
      primary: {
        main: colors.info.main,
      },
      background: {
        default: colors.background.default,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });
  const themeDark = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: colors.info.main,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });

  const [dataState, setDataState] = useState(defaultValue);
  const theme = useTheme();
  const [isError, setIsError] = useState(false);
  const setAlert = useSetRecoilState(AlertState);

  const formRef = useRef(null);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    convertNumbersToStrings(_data);
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    onSubmit(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (data?.id) {
      let newData = data;
      setDataState(newData);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  useEffect(() => {
    if (open) {
      setErrors([]);
    }
  }, [open]);

  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  return (
    <>
      {/* <ThemeProvider theme={darkMode ? themeDark : themeLight}> */}
      <Dialog
        // fullScreen
        open={open}
        PaperComponent={PaperComponent}
      >
        {/* Form chỉnh sửa tạo mới giá đất */}
        <form ref={formRef} method="post" encType="multipart/form-data">
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2 }}>
            {title ? title : "Nhóm chức năng"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ p: 1 }}>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              <Grid container spacing={2} sx={{ textAlign: "left" }}>
                <Grid item xs={12}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Tên nhóm <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={dataState.name}
                    error={errors ? !!errors.name : false}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        name: "",
                      });
                    }}
                    placeholder="Nhập tên nhóm"
                    helperText={errors.name}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("name")}
                    name="name"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Ghi chú
                  </Typography>
                  <TextField
                    value={dataState.note}
                    placeholder="Nhập ghi chú"
                    helperText={errors.note}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("note")}
                    name="note"
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {/* </ThemeProvider> */}
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

function validateOBJ(gd) {
  return {
    name: !validateRequired(gd.name) ? "Tên nhóm không được trống" : "",
  };
}

export default CRUDGroupMenu;
